module.exports = "<button aria-haspopup=\"true\" aria-expanded=\"{{ vm.isOpen }}\" ng-click=\"vm.toggle()\">\n    <span>&nbsp;</span>\n</button>\n<ul role=\"action-menu\" ng-transclude></ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/courses/authoringTool/editor/actionMenu/template.html
// module id = 1627
// module chunks = 0